<!--
 * @name: 
 * @Author: zxc
 * @Date: 2021-08-30 10:22:48
 * @LastEditors: zxc
 * @LastEditTime: 2021-08-30 16:10:32
-->
<template>
  <div>
    <el-menu
      :default-active="activeMenu"
      background-color="#756bb100"
      text-color="#fff"
      :unique-opened="false"
      active-text-color="rgb(229, 134, 18)"
      :collapse-transition="false"
      mode="horizontal"
    >
      <navbar-item v-for="route in role" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
  </div>
</template>

<script>
import NavbarItem from './NavbarItem'

export default {
  components: { NavbarItem },
  computed: {
    activeMenu() {
      // const route = this.$route
      // const { meta, path } = route
      // // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      // return path
      const route = this.$route
      console.log(route)
      // return route.path
      if (route.meta.guidePath) {
        return this.$store.getters.beforeRoute
      } else {
        return this.beforeNewRoute
      }
    }
  },
  data() {
    return {
      role: [
        {
          path: '/',
          meta: {
            title: '丹氏首页',
          }
        },
        {
          path: '/solution', // '/solution'
          meta: {
            title: '解决方案',
          },
          children: [
            {
              path: '/solution/1',
              meta: {
                title: '液氮冻存系统'
              }
            },
            {
              path: '/solution/2',
              meta: {
                title: '麒麟云无线监控系统'
              }
            },
            {
              path: '/solution/3',
              meta: {
                title: '麒麟云样本管理系统'
              }
            },
            {
              path: '/solution/4',
              meta: {
                title: '低温耗材'
              }
            }
          ]
        },
        {
          path: '/product',
          meta: {
            title: '产品中心',
          },
          children: [
            {
              path: '/product/1',
              meta: {
                title: '液氮冻存系统'
              },
              
            },
            {
              path: '/product/2',
              meta: {
                title: '麒麟云无线监控系统'
              }
            },
            {
              path: '/product/3',
              meta: {
                title: '麒麟云样本管理系统'
              }
            },
            {
              path: '/product/4',
              meta: {
                title: '低温耗材'
              },
              children: [
                {
                  path: '/product/4/1',
                  meta: {
                    title: '低温东村系统'
                  }
                },
                {
                  path: '/product/4/2',
                  meta: {
                    title: '低温东村系统2'
                  }
                }
              ]
            }
          ]
        },
        {
          path: '/about', // '/about'
          meta: {
            title: '走进丹氏',
          }
        },
        {
          path: '/servicesAndSupport', // '/customer'
          meta: {
            title: '服务与支持',
          }
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar/index.vue